module.exports = __webpack_public_path__ + "assets1763535487631/img/logo-block.b2a020b6.png";